<template>
  <action-dispatcher action="marketplace/getCredit">
    <div class="view-documents">
      <div class="tool-title">
        Correção de documentos
      </div>
      <div class="row">
        <div class="col-lg-8 py-4">
          <div class="card">
            <div class="card-body">
              <form-document
                :has-credits="hasCredit"
                @success="sentNewDoc"
                :item="credit"
              />
            </div>
          </div>
        </div>

        <div class="col-lg-4 py-4">
          <div class="card mb-5">
            <div class="card-body text-center">
              Você possui

              <h1 class="mb-0">{{ user.credit }}</h1>
              <div class="mb-3">créditos</div>
              <button class="btn btn-primary px-4" @click="buyCredits">
                Comprar Créditos
              </button>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <action-dispatcher
                action="documents/getAll"
                ref="documentsDispatcher"
              >
                <h6 v-if="documents.length === 0">Nenhum documento enviado</h6>
                <h6 v-else>Documentos enviados ({{ documents.length }})</h6>
                <a
                  v-for="(d, i) in documents"
                  :key="i"
                  class="btn btn-block mt-3 document px-4"
                  :href="d.file"
                  target="_blank"
                >
                  <div class="d-flex letter flex-column flex-fill text-left">
                    <strong class="flex-fill pr-4">{{ d.name }}</strong>
                    <small>{{ date(d) }}</small>
                  </div>
                  <strong v-html="status(d)" class="px-4"></strong>
                  <i class="icon-download"></i>
                </a>
              </action-dispatcher>
            </div>
          </div>
        </div>
      </div>

      <!-- <file-input v-if="credits > documents.length" @pick="pickFile" /> -->

      <b-modal v-model="dialog" hide-header hide-footer centered>
        <div v-if="file" class="p-3">
          <h5 class="mb-4 text-center">
            Deseja mesmo enviar o arquivo "{{ file.name }}"?
          </h5>
          <div class="d-flex justify-content-center align-items-center mx-n3">
            <button
              class="btn mx-3 px-5 btn-outline-light"
              @click="dialog = false"
            >
              Cancelar
            </button>
            <div class="flex-fill"></div>
            <button class="btn mx-3 px-5 btn-primary" @click="sendFile">
              <loading :show="loading">Confirmar</loading>
            </button>
          </div>
        </div>
      </b-modal>
    </div>
  </action-dispatcher>
</template>

<script>
import { mapState } from "vuex";
import get from "lodash/get";
import FormDocument from "@/components/documents/FormDocument";
export default {
  components: {
    FormDocument
  },
  data() {
    return {
      //credits: 5,
      file: null,
      dialog: false,
      loading: false,
      startSendFile: false
    };
  },
  computed: {
    ...mapState("documents", ["documents"]),
    ...mapState("user", ["user"]),
    ...mapState("marketplace", ["credit"]),
    hasCredit() {
      if (this.user.credit > 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    sentNewDoc() {
      this.$refs.documentsDispatcher.dispatch().finally(() => {
        this.$store.dispatch("user/get");
      });
      //this.$router.push({ name: "documents" });
    },
    status(d) {
      return {
        analyzed: "<span class='text-success'>Concluído</span>",
        in_analyse: "<span>Em análise</span>"
      }[d.status];
    },
    date(d) {
      const dateArr = d.created_at.split("T");
      return `${dateArr[0]
        .split("-")
        .reverse()
        .join("/")} às ${dateArr[1].substr(0, 5)}`;
    },
    pickFile(file) {
      this.file = file;
      this.dialog = true;
    },
    sendFile() {
      this.loading = true;
      this.$store
        .dispatch("documents/upload", this.file)
        .then(() => {
          this.dialog = false;
          this.file = null;
          this.$message.success("Arquivo enviado com sucesso!");
          this.$refs.documentsDispatcher.dispatch();
        })
        .catch(error => {
          const message = get(
            error.response,
            "message",
            "Erro! Por favor, tente novamente mais tarde."
          );
          this.$message.error(message);
        })
        .finally(() => {
          //this.$router.push({ name: "documents" });
          this.$store.dispatch("user/get");
          this.loading = false;
        });
    },
    buyCredits() {
      window.open(this.credit.url, "_blank").focus();
    }
  }
};
</script>

<style lang="scss" scoped>
.view-documents {
  .document {
    color: white;
    background: rgba(25, 25, 25);
    border-radius: 16px;
    display: flex;
    align-items: center;
    font-weight: normal;
  }

  .card {
    background: rgba(25, 25, 25, 0.6);
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    border: none;
  }

  .letter {
    word-break: break-word;
  }
}
</style>
